// extracted by mini-css-extract-plugin
export default {"itemsList":"Pharmacy_itemsList__XA4V6","searchIcon":"Pharmacy_searchIcon__puJrQ","staticMapDiv":"Pharmacy_staticMapDiv__88UeZ","staticMap":"Pharmacy_staticMap__pGluj"};